<template>
  <section class="yield-panel influence-panel">
    <div class="yield-title">关键影响因子</div>
    <div class="factor-list">
      <div v-for="item in factors" :key="item.name" class="factor-item">
        <span class="round-icon"><img src="../../assets/img/gj.png" alt="" /></span>
        <b>{{ item.name }}</b>
        <strong class="aqua-text">{{ item.value }}</strong>
      </div>
    </div>
  </section>
</template>

<script setup>
const factors = [
  { name: "历史产量权重", value: "34%", icon: "历" },
  { name: "积温贡献", value: "24%", icon: "温" },
  { name: "墒情贡献", value: "18%", icon: "墒" },
  { name: "病虫害修正", value: "12%", icon: "虫" },
];
</script>

<style lang="less" scoped>
@import "./YieldLeftShared.less";

.influence-panel {
  padding: 20px 28px 18px;
}

.factor-list {
  display: grid;
  gap: 40px;
  margin-top: 50px;
}

.factor-item {
  display: grid;
  grid-template-columns: 80px minmax(0, 1fr) 82px;
  align-items: center;
  gap: 14px;
  color: #ffffff;
}

.factor-item b {
  font-size: 32px;
  line-height: 34px;
  text-align: left;
  white-space: nowrap;
}

.factor-item strong {
  font-size: 33px;
  line-height: 40px;
  text-align: right;
}
.round-icon{
  img{
    width: 40px;
    height: 40px;
  }
}
</style>
